<!-- 空页面 -->
<template>
  <div></div>
</template>

<!-- 脚本代码 -->
<script>
export default {
  name: "Refresh",
  data() {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$router.replace(from.path);
    });
  },
};
</script>

<!-- 样式 -->
<style scoped></style>
